export const funIconStyle = (size?: string) => ({
  background: '#09798D',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: size ? size : '48px',
  width: size ? size : '48px',
  borderRadius: '50%',
});

export const iconStyle = (size?: string) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: size ? size : '48px',
  width: size ? size : '48px',
  borderRadius: '50%',
});
